<template>
  <div class="clientList">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        客户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;"  class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">商城账号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="bind_mobile" clearable size="small" placeholder="商城账号"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">备注名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="remark" clearable size="small" placeholder="备注名称"></el-input>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="center_list_head_rig" @click="dialogFormVisible = true">添加客户</div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <div v-show="group==7">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="联系人">
                  <span>{{ props.row.name }}</span>
                </el-form-item>
                <el-form-item label="联系方式">
                  <span>{{ props.row.link }}</span>
                </el-form-item>
                <el-form-item label="地址">
                  <span>{{ props.row.address }}</span>
                </el-form-item>
                <el-form-item label="商城账号">
                  <span>{{ props.row.bind_mobile }}</span>
                </el-form-item>
                <el-form-item label="商城备注">
                  <span>{{ props.row.remark_name != ''?props.row.remark_name:props.row.nickname }}</span>
                </el-form-item>
                <el-form-item label="订单数量">
                  <span>{{ props.row.order_num }}</span>
                </el-form-item>
                <el-form-item label="消费金额">
                  <span>{{ props.row.pay_sum_money }}</span>
                </el-form-item>
                <el-form-item label="注册时间">
                  <span>{{ props.row.create_date }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="商城账号" prop="bind_mobile"></el-table-column>
          <el-table-column label="负责人" prop="real_name"></el-table-column>
          <el-table-column label="备注名称">
            <template slot-scope="scope">
              <span v-if="scope.row.remark_name != ''">{{scope.row.remark_name}}</span>
              <span v-else>{{scope.row.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope" style="padding:0;margin:0">
              <router-link target="_blank" :to="'y_userLook/' + scope.row.mobile + '/' + 1">
                <el-link type="primary">查看</el-link>
              </router-link>
              <el-link
                @click="showRemark = true,
              remarkForm = tableData[scope.$index]"
                style="margin-left:10px"
                type="primary"
              >备注</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="group==0">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="联系人">
                  <span>{{ props.row.name }}</span>
                </el-form-item>
                <el-form-item label="联系方式">
                  <span>{{ props.row.link }}</span>
                </el-form-item>
                <el-form-item label="地址">
                  <span>{{ props.row.address }}</span>
                </el-form-item>
                <el-form-item label="商城账号">
                  <span>{{ props.row.bind_mobile }}</span>
                </el-form-item>
                <el-form-item label="商城备注">
                  <span>{{ props.row.remark_name != ''?props.row.remark_name:props.row.nickname }}</span>
                </el-form-item>
                <el-form-item label="订单数量">
                  <span>{{ props.row.order_num }}</span>
                </el-form-item>
                <el-form-item label="消费金额">
                  <span>{{ props.row.pay_sum_money }}</span>
                </el-form-item>
                <el-form-item label="注册时间">
                  <span>{{ props.row.create_date }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="商城账号" prop="bind_mobile"></el-table-column>
          <el-table-column label="备注名称">
            <template slot-scope="scope">
              <span v-if="scope.row.remark_name != ''">{{scope.row.remark_name}}</span>
              <span v-else>{{scope.row.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope" style="padding:0;margin:0">
              <router-link target="_blank" :to="'y_userLook/' + scope.row.mobile + '/' + 1">
                <el-link type="primary">查看</el-link>
              </router-link>
              <el-link
                @click="showRemark = true,
              remarkForm = tableData[scope.$index]"
                style="margin-left:10px"
                type="primary"
              >备注</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager1">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加客户 -->
    <el-dialog title="添加客户" :visible.sync="dialogFormVisible" width="600px">
      <el-form>
        <el-form-item label="客户手机号" >
          <el-input style="width:300px" clearable v-model="client_mobile"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户姓名" >
          <el-input style="width:300px" clearable v-model="client_name"  autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="add_sale_users()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 账号添加备注信息 -->
    <el-dialog title="备注账号" :visible.sync="showRemark" width="33%">
      <el-form :label-position="labelPosition" label-width="80px" :model="remarkForm">
        <el-form-item label="用户账号:">
          <el-input
            style="width:356px"
            v-model="remarkForm.bind_mobile"
            :disabled="true"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注名称:">
          <el-input style="width:356px" v-model="remarkForm.remark_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:">
          <el-input style="width:356px" v-model="remarkForm.link" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人:">
          <el-input style="width:356px" v-model="remarkForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址:">
          <el-input style="width:356px" v-model="remarkForm.address" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRemark = false">取 消</el-button>
        <el-button type="primary" @click="remark_client()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      serve: this.$store.state.serve,
      token: this.$cookies.get('token'),
      username: this.$cookies.get('username'),
      page: null,
      total: 0,
      tableData: [],
      remark: '',
      link: '',
      bind_mobile: '',
      client_mobile: '',
      client_name: '',
      showRemark: false,
      remarkForm: {
        link: '',
        name: '',
        address: ''
      },
      labelPosition: 'left',
      group: '',
      dialogFormVisible: false
    }
  },
  created() {
    this.$store.state.topActiveId = 9
    this.$store.state.leftTitle = '我的客户'
    this.geting()
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleAllSelection()
      }
    }
  },
  methods: {
    add_sale_users(){
      this.dialogFormVisible = true
      this.axios
        .get(this.serve + '/admin/add_sale_user', {
          params: {username: this.username,token: this.token,bind_mobile: this.client_mobile,nickname:this.client_name},
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
    
            this.alert_success('客户添加成功!')
            this.geting()
            this.dialogFormVisible = false
          } else {
            this.alert_error(data.msg)
            this.dialogFormVisible = false
          }
        })
    },
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    remark_client() {
     
      var where = {}
      where = this.remarkForm
      var parsmerge = Object.assign({username: this.username,token: this.token},where);
 
      this.axios
        .get(this.serve + '/admin/remark_client', {
          params: parsmerge
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.geting()
            this.showRemark = false
            this.alert_success('客户备注成功!')
            this.remarkForm = {}
          } else {
            this.alert_error(data.msg)
          }
        })
    },
    setPage(v) {
      //分页
      this.page = v
      this.geting(v)
      this.selectAll = false
    },
    geting(page) {
      //请求数据
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var that = this
      var where = {
        username: this.username,
        token: this.token,
        page: page ? page : this.page
      }
      if (this.link) {
        where.link = this.link
      }
      if (this.remark) {
        where.remark = this.remark
      }
      if (this.bind_mobile) {
        where.bind_mobile = this.bind_mobile
      }
      this.axios
        .get(this.serve + '/admin/get_client', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.tableData = data.data.results
            this.total = data.data.total
            this.page = data.data.page
            this.group = data.data.group
          } else {
            if(data.msg == "无权访问"){
              this.role = false
            }
            this.tableData = []
          }
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss">
.clientList {
    .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top:19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
  .el-form-item__label{
    width:100px;
  }
}
</style>